export enum SortOperationKind {
  ASC = 'ASC',
  DESC = 'DESC',
}
